<template>
  <div class="animated fadeIn">

    <div class="row">
      <div class="col-9">
        <h4><i class="fa fa-trophy"></i><span class="ml-1">Recharges</span></h4>
      </div>

      <div class="col-2">
        <h4>
          <h10> True Failure </h10>
          <label class="switch switch-outline-primary" >
            <input type="checkbox" class="switch-input" v-model="true_failure"  value=false
                   unchecked-value=true  @change="trueFailure">
            <span class="switch-slider"></span>
          </label>
        </h4>
      </div>

      <div class="col-1">
        <h4>
          <h10> Expand </h10>
          <label class="switch switch-outline-primary" >
            <input type="checkbox" class="switch-input" v-model="expand_column" value=false
                   unchecked-value=true>
            <span class="switch-slider"></span>
          </label>
        </h4>
      </div>


    </div>


    <div class="card">
      <v-client-table :data="recharges" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'SendGratification', params: {id: props.row.id}}">
              <span
                  class="btn btn-primary btn-sm m-1"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View"
              >
                <CIcon name="cil-magnifying-glass" size="sm" />
              </span>
            </router-link>
          </div>
        </template>

      </v-client-table>
    </div>


  </div>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "SubscriptionGratification",

  data() {


    return {
      expand_column: false,
      true_failure: false,
      recharges: [],
      tempRecharges: [],
      balance: "",
      date: new Date(),
      type: "",
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        dateColumns: ["created_at"],
        //dateFormat: 'DD-MM-YYYY',
        toMomentFormat: true,
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  computed: {
    columns: function(){
      if(!this.expand_column){
        return ["action", "phone", "status", "data_or_recharge", "data_message", "recharge_message",  "recharge_amount", "recharge_operator", "created_at"];
      }else{
        return ["action", "id", "user_id", "phone", "status", "data_or_recharge", "data_success", "data_message", "data_error_code", "recharge_status", "recharge_message", "recharge_trans_id", "recharge_msisdn", "recharge_amount", "recharge_con_type", "recharge_operator", "recharge_clientTrxId", "exception_code", "exception_message", "created_at", "updated_at"];
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      axios
          .get(`${ADMIN_URL}/recharge-data-list`)
          .then((response) => {
            this.recharges = response.data.map((x) => {

              const obj = {};
              obj.id = x.id;
              obj.user_id = x.user_id;
              obj.phone = x.phone;
              obj.status = x.status;
              obj.data_or_recharge = x.data_or_recharge;
              obj.data_success = x.data_success;
              obj.data_message = x.data_message;
              obj.data_error_code = x.data_error_code;
              obj.recharge_status = x.recharge_status;
              obj.recharge_message = x.recharge_message;
              obj.recharge_trans_id = x.recharge_trans_id;
              obj.recharge_msisdn = x.recharge_msisdn;
              obj.recharge_amount = x.recharge_amount;
              obj.recharge_con_type = x.recharge_con_type;
              obj.recharge_operator = x.recharge_operator;
              obj.recharge_clientTrxId = x.recharge_clientTrxId;
              obj.exception_code = x.exception_code;
              obj.exception_message = x.exception_message;
              obj.created_at = moment(x.created_at).format(
                  "DD/MM/YYYY, h:mm:ss a"
              );
              obj.updated_at = moment(x.updated_at).format(
                  "DD/MM/YYYY, h:mm:ss a"
              );
              return obj;
            });
          })
          .catch((error) => {
            console.log(error);
          });
    },

    trueFailure(e){
      if(!this.true_failure){
        return this.recharges = this.tempRecharges
      }
      this.tempRecharges = this.recharges
      let succeedPhone = []
      this.recharges.filter((item) => {
        if(item.status == 'SUCCEED'){
          succeedPhone.push(item.phone)
        }
      })

      this.recharges = this.recharges.filter((item) => {
        if (item.status == 'FAILED') return (!succeedPhone.includes(item.phone));
      })
    },


  }
}
</script>

<style scoped>

</style>
